import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-pending-payments-tab',
  templateUrl: './salvage-pending-payments-tab.component.html',
})
export class SalvagePendingPaymentsTabComponent {
  @Input() context!: SalvageTabContext;
}
